import script from "./CompanyIntro.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyIntro.vue?vue&type=script&setup=true&lang=js"

import "./CompanyIntro.vue?vue&type=style&index=0&id=18f9e246&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18f9e246"]])

export default __exports__